export const detailedReviews = [
    {
      id: 1,
      name: "Anna",
      location: "Russia",
      rating: 10,
      ratingOutOf: 10,
      date: "November 8, 2025",
      comment: "I would like to thank the wonderful villa and its owner. This is the 10th time I have flown to Sri Lanka, and I want to say that I have never seen such a caring approach. From start to finish, 10 out of 10. The owner is always in touch, helps to resolve any issues quickly and efficiently. I helped with the bike rental. By transfer. Any question. As for the villa, it's even better than in the photos. A huge villa with three bedrooms, a work area, a recreation area, a kitchen with beautiful dishes and everything you need. A washing machine, a dryer, and a lot of other amenities for a comfortable stay. The beautiful grounds with flowers and palm trees are perfectly complemented by a beautiful and cozy swimming pool. The location is also excellent. You can't hear the road, the cars don't honk, and the train doesn't make noise. It's just birds and quiet neighbors. I recommend this villa 10 out of 10.",
      avatar: ""
    },
    {
      id: 2,
      name: "Getachew",
      location: "Ethiopia",
      rating: 10,
      ratingOutOf: 10,
      date: "February 24, 2025",
      comment: "Fantastic experience!",
      avatar: ""
    },
    {
      id: 3,
      name: "Piti",
      location: "",
      rating: 5,
      ratingOutOf: 5,
      date: "June 2024",
      comment: "The house is very big and spacious. We were 6 peopels and we stayed there a week and we were very comfortable. Primali and her husband,  Sanath, were super nice and helped us with everything",
      avatar: "https://a0.muscache.com/im/pictures/user/d5747216-1a90-4d7d-bacd-427bfe40c3e8.jpg?im_w=240"
    },
    {
      id: 4,
      name: "Robin",
      location: "",
      rating: 5,
      ratingOutOf: 5,
      date: "February 24, 2025",
      comment: "Amazing big house with a lot of monkeys, chipmunks, birds and geckos around in the garden. Host was very proffessional and was always available to assist when anything was unclear or any problem showed up in the house. Would really recommend booking this villa for a month or more, you will fall in love with the place like we did.",
      avatar: "https://a0.muscache.com/im/pictures/user/05c76101-6c17-4568-b039-556fd7d6bfee.jpg?im_w=240"
    },
    {
      id: 5,
      name: "Maya",
      location: "Russia",
      rating: 5,
      ratingOutOf: 5,
      date: "February 2020",
      comment: "Spent 3 wonderful weeks in Dinoos house. Host is very friendly and responsive. Everything what we needed were in the house. Very calm villa with lots of animals around. Was amazing been watching monkeys from our balcony. The bathroom on the ground floor isn’t in the perfect condition but the others rooms were ok.  We could cook in the kitchen, used BBQ grill, did smoothies. Suggest Dinoos’s house.",
      avatar: "https://a0.muscache.com/im/pictures/user/c56eef58-4910-4e83-81fb-7d170c746d4a.jpg?im_w=240"
    },
    {
      id: 6,
      name: "Taras",
      location: "",
      rating: 5,
      ratingOutOf: 5,
      date: "February 2020",
      comment: "Very nice place to stay in Welligama. It's far from the busy roads and noise, but not too far from the beach to make it yourself without tuktuk service. Very roomy two-story apartment with literally everything you need for the pleasant stay. The kitchen has all the equipment to prepare food. A/C, WiFi and washing machine were working well. Plenty of space to work and rest, including big terrace with hammock. The host is happy to help with everything you need and always reachable in WhatsApp.  If you need a decent place for remote work, or you are a party of 4-6 people don't hesitate to book this villa, you will not be disappointed.",
      avatar: "https://a0.muscache.com/im/pictures/user/aa741c8b-b286-4a43-9fc6-6ab241302965.jpg?im_w=240"
    }
  ];